import api from '@lib/api'
import { useQuery } from '@tanstack/react-query'

export interface TripDayInfo {
	tripId: number
	dayIndex: number
	name: string | null
	note: string | null
	isSkipped: boolean
}

export interface GetTripDayInfosResponse {
	tripDayInfo: TripDayInfo[]
}

export const useTripDayInfos = (tripId: string | undefined) => {
	return useQuery<GetTripDayInfosResponse>({
		queryKey: ['tripDayInfos', tripId],
		queryFn: async () => {
			const response = await api.get<GetTripDayInfosResponse>(`/trips/${tripId}/tripDayInfo`)
			return response.data
		},
		enabled: !!tripId,
	})
}
